export class DocumentNotification {
  ccMckay?: boolean;
  users?: number[];
  subject?: string;
  message?: string;
  banner?: string;
}
